import { Box, Heading, Text } from '@wix/design-system';
import {
  FeatureSection as FeatureSectionComp,
  Types,
} from '@wix/package-picker-components';
import { RootStore, withInjectedRootStore } from 'providers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AdvancedPlansFeatureSection,
  AdvancedPlansProductData,
} from '../../../types';
import { FeatureRow } from './FeatureRow';
import s from './FeatureSection.scss';

interface FeatureSectionProps {
  section: AdvancedPlansFeatureSection;
  products: AdvancedPlansProductData[];
  isOpen?: boolean;
  isJapanesePackagePicker?: boolean;
  rootStore: RootStore;
}

const FeatureSection: React.FC<FeatureSectionProps> = ({
  section,
  products,
  isOpen: isOpenDefault = false,
  isJapanesePackagePicker = false,
  rootStore,
}) => {
  const { t } = useTranslation();

  const {
    appStore: {
      planType,
      appContext: { siteGuid, biLogger },
    },
  } = rootStore;

  const onClick = (action: Types.CollapsibleAction) => {
    biLogger.logClickOnShowFeatures({
      showFeatureType: section.translationKey,
      clickType: action === 'close' ? 'hide' : 'show',
      ppType: planType,
      siteGuid,
    });
  };

  return (
    <FeatureSectionComp isOpen={isOpenDefault}>
      <FeatureSectionComp.Header
        labels={{
          open: t('Advanced.Plans_General_Show_features'),
          close: t('Advanced.Plans_General_Hide_features'),
        }}
        onToggle={onClick}
      >
        <FeatureSectionComp.Hoverable
          render={(isHovering) => (
            <Box direction='vertical'>
              <Heading appearance='H4' className={s.sectionTitle}>
                {t(section.translationKey)}
              </Heading>
              <Text size='small' skin={isHovering ? 'primary' : 'standard'}>
                {t(section.descriptionTranslationKey)}
              </Text>
            </Box>
          )}
        />
      </FeatureSectionComp.Header>
      <FeatureSectionComp.Features>
        {section.features.map((f) => (
          <FeatureRow
            feature={f}
            key={f.translationKey}
            products={products}
            isJapanesePackagePicker={isJapanesePackagePicker}
          />
        ))}
      </FeatureSectionComp.Features>
    </FeatureSectionComp>
  );
};

export default withInjectedRootStore(FeatureSection);
